import { CSSObject } from '@chakra-ui/react';

export const TextItem: CSSObject = {
  textTransform: 'uppercase',
  fontFamily: 'body',
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'bold',
};
